import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  CustomInput,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';
import { connect } from 'react-redux';
import { IDivisionAnswer, IAuthReduxProps, ITarget } from '../../types/interfaces';

import AssociationFields from '../vente/bien/VAssociationFields';
import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { answerDivision } from '../../flux/actions/divisionActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faExternalLinkAlt, faPen, faSpinner, faLockOpen, faSyncAlt, faCommentsDollar, faMoneyBill, faRulerCombined, faSquare, faCheckSquare, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';
import { PRIVILEGE } from '../../types/privileges'
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import ReactTooltip from 'react-tooltip';
import Association from '../consultation/Association';

const DivisionDelete = ({
  modal,
  setModal,
  handleToggle,
  modalData,
  answerDivision,
  answer,
  auth
 }: IDivisionAnswer) => {
  const alert = useAlert();

  const [idValue, setIdValue] = useState(-1);
  const [bienValue, setBienValue] = useState<any>('');
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const [saveSample, setSaveSample] = useState(false);
  const [sampleName, setSampleName] = useState('');

  const sampleNameChangeHandler = (e: ITarget) => setSampleName(e.target.value);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  const modalOpenedHandle = () => {
    if(modalData && modalData !== ''){
      setIdValue(modalData["id"]);
      setBienValue(modalData["bien"]);
    }
  };

  const modalClosedHandle = () => {
    setIdValue(-1);
    setBienValue('');
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };

  const callback = (success, approved) => {
    if(success){
      setReEnable(true);
      setModal(false);
      alert.success(`Demande ${approved ? "acceptée" : "refusée"} avec succès`);
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const answerHandle = async () => {
    if(idValue === -1)
      return
    if(saveSample && !sampleName){
      alert.error("Veuillez saisir un nom");
      return
    }
    setDisableSubmit(true);
    answerDivision(idValue, bienValue["id"], answer, saveSample ? 1 : 0, sampleName, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : undefined, callback);
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={handleToggle} onOpened={modalOpenedHandle} onClosed={modalClosedHandle} className="modal-dialog-large">
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faLockOpen} />&nbsp;&nbsp;Répartition d'association</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row className="mb-2">
                Voulez-vous vraiment&nbsp;<b>{answer ? "accepter" : "refuser"}</b>&nbsp;la demande de répartition d'association du bien&nbsp;<b>{bienValue ? bienValue["DESIGNATION"] : ""}</b>&nbsp;?
              </Row>
              <Row>
                <Col xs="12">
                  <h6 className="text-center" style={{color: !modalData ? "red" : modalData.approved === 1 ? "green" : "orange"}}>{modalData ? modalData.approved === 1 ? "Répartition validée" : "Répartition pas encore validée" : "Aucune répartition n'est proposée"}</h6>
                  {!!modalData && <Association etages={bienValue.ETAGE_ASS} division={modalData} />}
                </Col>
              </Row>
              {!!(auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION) && modalData && !modalData?.divisionSampleId) && <div className="fullFlexCenter">
                <CustomInput type="switch" id="saveSample" name="saveSampleSwitch" label="Enregistrer un nouveau groupe" checked={saveSample} onChange={e => setSaveSample(e.target.checked)} />
              </div>}
              {!!saveSample && <Row className="justify-content-center">
                <Col xs="12" sm="4" style={{border: "none"}}>
                  <Input id="sampleName" type="text" placeholder="Nom du Groupe..." value={sampleName} onChange={sampleNameChangeHandler} className="form-control" />
                </Col>
              </Row>}
              <Row className="justify-content-center">
                <Button
                  className={`btn btn-${answer ? "success" : "danger"} linesConfirmationBtn linesDeleteBtn`}
                  onClick={answerHandle}
                  disabled={disableSubmit || !auth?.user?.privileges?.includes(PRIVILEGE.APPROVE_DIVISION)}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faLockOpen} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;{answer ? "Accepter" : "Refuser"}</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>
    </div>  
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
  error: state.error
});

export default connect(mapStateToProps, { answerDivision })(DivisionDelete);
